// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-field[data-v-82524ff4] {\n  position: absolute;\n  z-index: 2;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.draggable-field.is-selected[data-v-82524ff4] {\n  z-index: 3;\n}", ""]);
// Exports
module.exports = exports;
